<template>
  <CRow class="mx-1">
    <CCol>
      <CRow>
        <CCol :fluid="true" md="" sm="12" v-if="isSuper">
          <b-form-group :label="$store.state.form.mitra" label-for="mitra">
            <multiselect
              id="mitra"
              class="m-0 p-0"
              style="white-space: nowrap"
              v-model="filter.mitra"
              :options="listMitra"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              label="namaMitra"
              track-by="id"
              :placeholder="$store.state.form.pilihMitra"
              size="sm"
              @input="getKoordinator(filter.mitra), (filter.koordinator = null), (filter.cabang = null), (filter.capem = null), getDatas()"
            ></multiselect>
          </b-form-group>
        </CCol>

        <CCol :fluid="true" md="" sm="12">
          <b-form-group :label="$store.state.form.koordinator" label-for="koordinator">
            <multiselect
              id="koordinator"
              class="m-0 p-0"
              style="white-space: nowrap"
              v-model="filter.koordinator"
              :options="listKoordinator"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              label="namaKoordinator"
              track-by="koordinatorId"
              :placeholder="$store.state.form.pilihKoordinator"
              size="sm"
              @input="getCabang(filter.koordinator), (filter.cabang = null), (filter.capem = null), getDatas()"
            ></multiselect>
          </b-form-group>
        </CCol>

        <CCol :fluid="true" md="" sm="12">
          <b-form-group :label="$store.state.form.cabang" label-for="cabang">
            <multiselect
              id="cabang"
              class="m-0 p-0"
              style="white-space: nowrap"
              v-model="filter.cabang"
              :options="listCabang"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              label="namaCabang"
              track-by="cabangId"
              :placeholder="$store.state.form.pilihCabang"
              size="sm"
              @input="getCapem(filter.cabang), (filter.capem = null), getDatas()"
            ></multiselect>
          </b-form-group>
        </CCol>

        <CCol :fluid="true" md="" sm="12">
          <b-form-group :label="$store.state.form.capem" label-for="capem">
            <multiselect
              id="capem"
              class="m-0 p-0"
              style="white-space: nowrap"
              v-model="filter.capem"
              :options="listCapem"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              label="namaCapem"
              track-by="capemId"
              :placeholder="$store.state.form.pilihCapem"
              size="sm"
              @input="getDatas()"
            ></multiselect>
          </b-form-group>
        </CCol>
      </CRow>

      <CRow>
        <CCol md="6" sm="12">
          <b-form-group :label="$store.state.form.divisi" label-for="divisi">
            <multiselect
              id="divisi"
              class="m-0 p-0"
              style="white-space: nowrap"
              v-model="filter.divisi"
              :options="listDivisi"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              label="namaDivisi"
              track-by="masterDivisiId"
              :placeholder="$store.state.form.pilihDivisi"
              size="sm"
              @input="getPosisi(filter.divisi), (filter.posisi = null), getDatas()"
            ></multiselect>
          </b-form-group>
        </CCol>

        <CCol md="6" sm="12">
          <b-form-group :label="$store.state.form.posisi" label-for="posisi">
            <multiselect
              id="posisi"
              class="m-0 p-0"
              style="white-space: nowrap"
              v-model="filter.posisi"
              :options="listPosisi"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              label="namaPosisi"
              track-by="masterPosisiId"
              :placeholder="$store.state.form.pilihPosisi"
              size="sm"
              @input="getDatas()"
            ></multiselect>
          </b-form-group>
        </CCol>
      </CRow>

      <CRow>
        <CCol sm="12" md="4">
          <b-form-group :label="$store.state.form.jenisKelamin" label-for="periode">
            <b-form-select id="periode" v-model="filter.jenisKelamin" :options="optionsKelamin"></b-form-select>
          </b-form-group>
        </CCol>
        <CCol sm="12" md="4">
          <b-form-group :label="$store.state.form.statusKerja" label-for="periode">
            <b-form-select id="periode" v-model="filter.statusPerjanjian" :options="optionsStatusKerja"></b-form-select>
          </b-form-group>
        </CCol>
        <CCol sm="12" md="4">
          <b-form-group :label="$store.state.form.pendidikan" label-for="periode">
            <b-form-select id="periode" v-model="filter.pendidikanTerakhir" :options="optionsPendidikanTerakhir"></b-form-select>
          </b-form-group>
        </CCol>

        <CCol col="6">
          <b-form-group :label="$store.state.form.usia" label-for="usia">
            <b-input-group>
              <b-form-input id="usia" type="number" :placeholder="$store.state.form.minUsia" v-model="filter.umurMinimal" debounce="500"></b-form-input>
              <b-form-input id="usia" type="number" :placeholder="$store.state.form.maxUsia" v-model="filter.umurMaksimal" debounce="500"></b-form-input>
            </b-input-group>
          </b-form-group>
        </CCol>

        <CCol col="6">
          <b-form-group :label="$store.state.form.masaKerja" label-for="masaKerja">
            <b-input-group>
              <b-form-input id="masaKerja" type="number" :placeholder="$store.state.form.minMasaKerja" v-model="filter.masaKerjaMinimal" debounce="500"></b-form-input>
              <b-form-input id="masaKerja" type="number" :placeholder="$store.state.form.maxMasaKerja" v-model="filter.masaKerjaMaximal" debounce="500"></b-form-input>
            </b-input-group>
          </b-form-group>
        </CCol>

        <CCol sm="12" md="2" class="pl-0 mb-1">
          <div class="w-100 h-100 d-flex align-items-end">
            <b-button variant="success" class="d-block w-100" v-c-tooltip.hover.click="'Reset'" @click="printList()">
              {{ $store.state.form.cetakList }}
            </b-button>
          </div>
        </CCol>

        <CCol sm="12" md="2" class="pl-0 mb-1">
          <div class="w-100 h-100 d-flex align-items-end">
            <b-button variant="danger" class="d-block w-100" v-c-tooltip.hover.click="'Reset'" @click="reset()">
              {{ $store.state.form.reset }}
            </b-button>
          </div>
        </CCol>
      </CRow>
    </CCol>

    <CCol col="12" class="mt-1 mb-2"><hr /></CCol>

    <CCol col="12">
      <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
        <template #namaTanggalSudahDitempatkan-filter>
          <date-picker style="width: 100%" v-model="filter.tanggalSudahDitempatkan" format="DD MMMM YYYY" required></date-picker>
        </template>
        <template #namaStatusPerjanjianAktif-filter>
          <b-form-select v-model="filter.statusPerjanjianAktif" :options="optionsStatusPerjanjianAktif"></b-form-select>
        </template>
        <template #Actions="{ item }">
          <td>
            <b-button variant="secondary" class="mr-1" v-c-tooltip.hover.click="'Print Data Diri'" @click="setPrint(item)" :disabled="!isSuper && !item.mitraId"><CIcon name="cil-print" /></b-button>
            <b-button variant="warning" class="mr-1" v-c-tooltip.hover.click="'Edit Data'" @click="editData(item)" :disabled="!isSuper && !item.mitraId"><CIcon name="cil-pencil" /></b-button>
          </td>
        </template>
      </CDataTable>

      <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
    </CCol>

    <ModalPrint :printData="printData" />
  </CRow>
</template>

<script>
import ModalPrint from "./modalPrint.vue";
import debounce from "lodash/debounce";
export default {
  components: {
    ModalPrint,
  },
  name: "asuransi",
  props: ["listMitra", "listDivisi"],
  data() {
    return {
      detail: false,
      data: {},
      printData: null,
      listKoordinator: [],
      listCabang: [],
      listCapem: [],
      listPosisi: [],
      items: [],
      filter: {
        cabang: null,
        posisi: null,
        jenisKelamin: null,
        statusPerjanjian: null,
        statusKerjaKaryawan: 0,
        pendidikanTerakhir: null,
        umurMinimal: null,
        umurMaksimal: null,
        masaKerjaMinimal: null,
        masaKerjaMaximal: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsKelamin: [
        { value: null, text: "silahkan Pilih" },
        { value: "Laki-laki", text: "Laki-laki" },
        { value: "Perempuan", text: "Perempuan" },
      ],
      optionsStatusKerja: [
        { value: null, text: "silahkan Pilih" },
        { value: "0", text: "Kontrak" },
        { value: "1", text: "Permanen" },
        { value: "2", text: "Alih Daya" },
      ],
      optionsPendidikanTerakhir: [
        { value: null, text: "silahkan Pilih" },
        { value: "SD", text: "SD" },
        { value: "SMP", text: "SMP" },
        { value: "MTs", text: "MTs" },
        { value: "SMA", text: "SMA" },
        { value: "SMK", text: "SMK" },
        { value: "MA", text: "MA" },
        { value: "D-1", text: "D-1" },
        { value: "D-2", text: "D-2" },
        { value: "D-3", text: "D-3" },
        { value: "D-4", text: "D-4" },
        { value: "S-1", text: "S-1" },
        { value: "S-2", text: "S-2" },
        { value: "Profesi", text: "Profesi" },
        { value: "Kejar Paket C", text: "Kerjar Paket C" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    isSuper() {
      return this.$store.state.role_aktif.kodeRole == "super";
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "NIK",
          label: this.$store.state.table.NIK,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "alamatKaryawan",
          label: this.$store.state.table.alamatKaryawan,
          _style: "max-width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "penempatan",
          label: this.$store.state.table.penempatan,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        // {
        //   key: "namaDivisi",
        //   label: this.$store.state.table.namaDivisi,
        //   _style: "max-width: 9%;",
        //   sortDirection: "desc",
        //   class: "text-left",
        //   sorter: false,
        // },
        {
          key: "namaPosisi",
          label: this.$store.state.table.posisi,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];
      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
    kode() {
      return this.$store.state.kode_client ? this.$store.state.kode_client : null;
    },
    print_url() {
      const base = this.$be;
      if (process.env.NODE_ENV === "production") {
        return `${base}/api-${this.kode}/`;
      }
      return "http://localhost:3000/";
    },
  },
  mounted() {
    this.getDatas();
    // this.getPosisi();
    // this.getCabang();
    this.reset();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    filter: {
      deep: true,
      handler() {
        this.debounceGetDatas();
      },
    },
  },
  methods: {
    debounceGetDatas: debounce(function () {
      this.getDatas();
    }, 1000),
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      this.debounceGetDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listSudahDitempatkan = await vm.$axios.post("dataKaryawan/filterDataKaryawanPerHalaman", {
        ...vm.filter,
        mitraId: vm.filter.mitra ? vm.filter.mitra.id : null,
        koordinatorId: vm.filter.koordinator ? vm.filter.koordinator.koordinatorId : null,
        cabangId: vm.filter.cabang ? vm.filter.cabang.cabangId : null,
        capemId: vm.filter.capem ? vm.filter.capem.capemId : null,
        masterPosisiId: vm.filter.posisi ? vm.filter.posisi.masterPosisiId : null,
        masterDivisiId: vm.filter.divisi ? vm.filter.divisi.masterDivisiId : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listSudahDitempatkan", listSudahDitempatkan);
      vm.items =
        listSudahDitempatkan.data.status == 200
          ? listSudahDitempatkan.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.dataKaryawanId,
                namaMitra: x.namaMitra || " - ",
                NIK: x.NIK ? x.NIK : " - ",
                namaDivisi: x.namaDivisi ? x.namaDivisi : " - ",
              };
            })
          : [];
      vm.totalRows = Number(listSudahDitempatkan.data.count);
      vm.loading = false;
    },
    async getKoordinator(x) {
      const vm = this;
      if (x) {
        let listKoordinator = await vm.$axios.get("/koordinator/listKoordinatorByMitraId/" + x.id);
        //   console.log(listKoordinator.data.data, "ini listKoordinator");
        this.listKoordinator = listKoordinator.data.data;
      }
    },
    async getCabang(x) {
      const vm = this;
      if (x) {
        let listCabang = await vm.$axios.get("/cabang/listCabangByKoordinatorId/" + x.koordinatorId);
        // console.log(listCabang.data.data, "ini listCabang");
        vm.listCabang = listCabang.data.data;
      }
    },
    async getCapem(x) {
      const vm = this;
      if (x) {
        let listCapem = await vm.$axios.get("/capem/listCapemByCabangId/" + x.cabangId);
        //   console.log(listCapem.data.data, "ini listCapem");
        this.listCapem = listCapem.data.data;
      }
    },
    async getPosisi(x) {
      let vm = this;
      if (x) {
        let listPosisi = await vm.$axios.get("/masterPosisi/listPosisiByMasterDivisiId/" + x.masterDivisiId);
        // console.log('listPosisi', listPosisi)
        vm.listPosisi = listPosisi.data.data;
      }
    },
    editData(data) {
      let vm = this;
      let routeData = vm.$router.resolve({
        name: "Detail Karyawan",
        query: { dataKaryawanId: data.dataKaryawanId },
      });
      window.open(routeData.href, "_blank");
    },
    async reset() {
      const vm = this;
      vm.filter = {
        mitra: vm.$store.state.mitra_aktif,
        koordinator: vm.$store.state.koordinator_aktif,
        cabang: vm.$store.state.cabang_aktif,
        capem: vm.$store.state.capem_aktif,
        divisi: null,
        posisi: null,
        jenisKelamin: null,
        statusPerjanjian: null,
        pendidikanTerakhir: null,
        umurMinimal: null,
        umurMaksimal: null,
        masaKerjaMinimal: null,
        masaKerjaMaximal: null,
      };
      await vm.getKoordinator(vm.filter.mitra);
      await vm.getCabang(vm.filter.koordinator);
      await vm.getCapem(vm.filter.cabang);
      vm.getDatas();
    },
    async setPrint(x) {
      console.log(x);
      let vm = this;
      let print = await vm.$axios.get("dataKaryawan/coverDataDiri/" + x.dataKaryawanId);
      let y = print.data.data[0];
      let jmlAnak = 0;
      if (y.pengalamanKerja.length) {
        let z = y.pengalamanKerja.length - 1;
        y.pengalamanPrint = "sebagai " + y.pengalamanKerja[z].jabatan + " di " + y.pengalamanKerja[z].namaPerusahaan + " " + y.pengalamanKerja[z].tahun + " tahun";
      }
      y.keluarga.forEach((el) => {
        if (el.statusDalamKeluarga == "Istri" || el.statusDalamKeluarga == "Suami") {
          y.pasangan = el.nama;
          y.tanggalPasangan = vm.$moment(el.tanggalLahir).format("LL");
        } else if (el.statusDalamKeluarga == "Anak") {
          if (jmlAnak < 3) {
            jmlAnak++;
            y[`anak${jmlAnak}`] = el.nama;
            y[`tanggalAnak${jmlAnak}`] = vm.$moment(el.tanggalLahir).format("LL");
          }
        }
      });
      if (print) y.tanggal = vm.$moment().format("LL");
      y.tanggalMulaiKerjaPrint = vm.$moment(y.tanggalMulaiKerja).format("LL");
      y.tanggalLahirKaryawanPrint = vm.$moment(y.tanggalLahirKaryawan).format("LL");
      if (y.statusPerjanjian == 0) {
        y.statusPerjanjianPrint = "KONTRAK";
      } else {
        y.statusPerjanjianPrint = "TETAP";
      }
      if (y.statusKaryawan) {
        y.statusKaryawan = y.statusKaryawan.toUpperCase();
      }
      vm.printData = y;
      vm.$bvModal.show("modal-print");
    },
    printList() {
      let vm = this;
      let query = "?";

      let mitra = vm.$store.state.mitra_aktif;
      if (mitra) {
        query += `mitraId=${mitra.id}&`;
      }
      if (vm.filter.koordinator) {
        query += `koordinatorId=${vm.filter.koordinator.koordinatorId}&`;
      }
      if (vm.filter.cabang) {
        query += `cabangId=${vm.filter.cabang.cabangId}&`;
      }
      if (vm.filter.capem) {
        query += `capemId=${vm.filter.capem.capemId}&`;
      }
      if (vm.filter.umurMinimal) {
        query += `umurMinimal=${vm.filter.umurMinimal}&`;
      }
      if (vm.filter.umurMaksimal) {
        query += `umurMaksimal=${vm.filter.umurMaksimal}&`;
      }
      if (vm.filter.statusPerjanjian) {
        query += `statusPerjanjian=${vm.filter.statusPerjanjian}&`;
      }
      if (vm.filter.jenisKelamin) {
        query += `jenisKelamin=${vm.filter.jenisKelamin}&`;
      }
      if (vm.filter.posisi) {
        query += `masterPosisiId=${vm.filter.posisi.masterPosisiId}&`;
      }
      if (vm.filter.divisi) {
        query += `masterDivisiId=${vm.filter.divisi.masterDivisiId}&`;
      }
      let url = vm.print_url + `dataKaryawan/cetakDataKaryawan/` + query;
      console.log(url);
      window.open(url, "_blank");
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
